<script lang="ts" setup></script>

<template>
  <div class="mt-16" style="position: relative">
    <div
      style="
        position: absolute;
        opacity: 0.5;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      "
      class="bg-green-lighten-5"
    />
    <v-container style="position: relative" class="py-16 text-center">
      <h2 class="font-indie pb-4" style="font-size: 2.125rem">
        Probeer vandaag nog onze gratis demo uit
      </h2>
      <div style="font-size: 1.125rem">
        <p class="ma-0">
          Nog niet zeker over het product en wil je het eerst uitproberen?
        </p>
        <p class="ma-0">Dat kan met onze gratis demo!</p>
      </div>

      <div class="pt-8">
        <v-btn
          variant="flat"
          size="large"
          :to="{ name: 'aanvraagformulier' }"
          color="primary"
        >
          Demo aanvragen
        </v-btn>
      </div>
    </v-container>
  </div>
</template>
